export const meta = { id: 'O29', slug: 'pre-requisitos', title: 'Como configurar Pré-requisitos', description: 'Controle a liberação de Componentes com dependências reais dentro da Formação.', profile: 'owner', category: 'formacoes', type: 'task', status: 'published', order: 590, keywords: ['pré-requisito','bloqueado','liberar','formação','componente'], previous: 'O28', next: 'O30', related: ['O25','A07'], updatedAt: '2026-08-17', appVersion: 'v1' }

# Como configurar Pré-requisitos

Pré-requisitos determinam quando um Componente pode ser liberado para execução.

<HelpImage pendingId="O28.1" alt="Configuração de pré-requisito em um Componente" />

<Steps>
  <Step title="Identifique a dependência real">Defina qual experiência precisa ser concluída antes da próxima.</Step>
  <Step title="Configure o pré-requisito">Use a opção disponível no Componente correspondente.</Step>
  <Step title="Salve e revise o currículo">Confirme a relação entre os Componentes.</Step>
  <Step title="Teste a experiência">Verifique se o próximo Componente fica bloqueado e é liberado após a conclusão esperada.</Step>
</Steps>

<Callout type="important">Pré-requisito é uma regra real de liberação, não apenas uma recomendação escrita ao participante.</Callout>
